import React from 'react';
import { Result } from 'antd';
import check from './CheckPermissions';
import Unauthorized from './Unauthorized';

const Authorized = ({ children, authority, noMatch = Unauthorized }) => {
  const childrenRender = typeof children === 'undefined' ? null : children;
  const dom = check(authority, childrenRender, noMatch);
  return <>{dom}</>;
};

export default Authorized;
